export enum LoginByTokenErrorCodes {
    AuthTokenExpired = "AuthTokenExpired",
    AuthTokenError = "AuthTokenError",
}
